import { Link as RouterLink, useNavigate } from "react-router-dom";
import { XyncelyLogo } from "../IconsImport";
import "./LandingNavbar.css";

const LandingNavbar = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleHypedClick = () => {
  const hypexSection = document.getElementById("hypex-section");

  if (hypexSection) {
    hypexSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

  const handleAccessClick = () => {
    // Add your desired action here
  };

  return (
    <nav className="landing-navbar">
      <div className="landing-navbar__container">

        {/* Logo */}
        <RouterLink
          to="/"
          className="landing-navbar__logo"
          onClick={handleLogoClick}
        >
          <img
            src={XyncelyLogo}
            alt="Xyncely"
          />
        </RouterLink>

        {/* Actions */}
        <div className="landing-navbar__actions">
          <button
            type="button"
            className="landing-navbar__hyped"
            onClick={handleHypedClick}
          >
            I’m Feeling Hyped
          </button>

          {/* <button
            type="button"
            className="landing-navbar__access"
            onClick={handleAccessClick}
          >
            Get Access
          </button> */}
        </div>

      </div>
    </nav>
  );
};

export default LandingNavbar;